import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const RTL_LANGUAGES = ['he', 'ar', 'fa', 'ur'];

/**
 * Subscribes to i18next language changes and keeps `document.dir` /
 * `document.lang` in sync. Returns `isRTL` so callers can adjust MUI theme.
 */
export function useDirection(): { isRTL: boolean } {
    const { i18n } = useTranslation();
    const [isRTL, setIsRTL] = useState(
        RTL_LANGUAGES.includes(i18n.language?.split('-')[0] ?? 'en')
    );

    useEffect(() => {
        const applyDirection = (lng: string) => {
            const lang = lng.split('-')[0];
            const rtl = RTL_LANGUAGES.includes(lang);
            document.documentElement.dir = rtl ? 'rtl' : 'ltr';
            document.documentElement.lang = lang;
            setIsRTL(rtl);
        };

        applyDirection(i18n.language ?? 'en');
        i18n.on('languageChanged', applyDirection);
        return () => {
            i18n.off('languageChanged', applyDirection);
        };
    }, [i18n]);

    return { isRTL };
}
